module.exports = __webpack_public_path__ + "static/img/1.7eca4f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/408/1.png
// module id = 483
// module chunks = 1